export default __webpack_public_path__ + "static/media/phone.92645915.svg";